var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticStyle:{"font-size":"1.5rem","margin":"2.5rem","color":"rgba(0, 0, 0, 0.85)"}},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticStyle:{"margin":"0 1.875rem"},domProps:{"innerHTML":_vm._s(_vm.msg)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }